// vendor
import { computed, ref, Ref, ComputedRef } from "@vue/composition-api";
// project
import { useListSort } from "@/hooks/useListSort";
import { Study } from "@/psychlab/types/studies";

type RT<T> = Ref<T>|ComputedRef<T>;

export const useRecentStudies = (studies:RT<Study[]>, days:RT<number>) => {

	const asc = ref(false);

	const recentStudies = computed(() => {
		// return studies.value.filter(a => {
		// 	return (new Date(a.lastVisited).getTime()) >= peekDate.value;
		// });
		return studies.value;
	});

	const {
		sorted
	} = useListSort(recentStudies, asc, s => (new Date(s.lastVisited)).getTime());

	const peekDate = computed(() => Date.now() - (days.value * 24 * 60 * 60 * 1000));

	return {
		studies:sorted,
		peekDate,
	};
};